.kr{white-space:nowrap;}